module.exports = __webpack_public_path__ + "img/pro_jinniao_02.02d66584.png";